export default "__VITE_ASSET__5d2d74b6__"